/**
 * Lista de "Materiais a cadastrar" no celular (auditoria mobile 2026-09-24,
 * S2): a tabela de seis colunas em 307px empilhava quatro botões por linha
 * (vinte na primeira tela) e reduzia Origem/Tipo/Sobras a "P…", "C…", "0..".
 *
 * Card por material: nome e referência, origem e tipo como texto corrido,
 * selo de situação, UMA ação primária cheia ("Cadastrar", 44px) e o resto
 * no menu "⋯". A lógica das ações é a mesma da tabela — vem por props.
 */
import React, { useEffect, useState } from "react";
import { FiMoreHorizontal } from "react-icons/fi";
import styled from "styled-components";

import { MenuItem, MenuList, MenuWrapper } from "../../../components/EntityHeader/styles.jsx";
import { ESTADO_SC_LABEL, ESTADO_SC_TONE } from "../../../services/suprimentos";
import { fmtData } from "../helpers";
import { CardItem, CardLista, IconBtn } from "../_shared/quadro/styles";
import { Pill, PrimaryButton } from "../styles";

const ABERTOS = ["PENDENTE", "EM_ANALISE"];

const BtnMenu = styled(IconBtn)`
  width: var(--tap-min);
  height: var(--tap-min);
`;

function MenuSecundario({ itens, nome }) {
  const [aberto, setAberto] = useState(false);
  useEffect(() => {
    if (!aberto) return undefined;
    const fechar = () => setAberto(false);
    document.addEventListener("click", fechar);
    return () => document.removeEventListener("click", fechar);
  }, [aberto]);
  if (!itens.length) return null;
  return (
    <MenuWrapper onClick={(e) => e.stopPropagation()}>
      <BtnMenu type="button" aria-label={`Mais ações para ${nome}`} aria-haspopup="menu" aria-expanded={aberto} onClick={() => setAberto((v) => !v)}>
        <FiMoreHorizontal size={18} />
      </BtnMenu>
      {aberto ? (
        <MenuList role="menu">
          {itens.map((it) => (
            <MenuItem key={it.label} $danger={it.danger}>
              <button type="button" role="menuitem" style={{ minHeight: "var(--tap-min)" }} onClick={() => { setAberto(false); it.onClick(); }}>{it.label}</button>
            </MenuItem>
          ))}
        </MenuList>
      ) : null}
    </MenuWrapper>
  );
}

function metaDe(l) {
  return [
    fmtData(l.created_at),
    l.produto_codigo,
    l.chave_externa && !l.chave_externa.startsWith("MANUAL-") ? `ref. ${l.chave_externa}` : null,
    l.motivo_rejeicao,
  ].filter(Boolean).join(" · ");
}

export default function CardsMateriais({
  linhas, podeAprovar, podeCriar, onAnalisar, onCadastrar, onRejeitar, onCancelar,
}) {
  return (
    <CardLista data-testid="materiais-cards">
      {linhas.map((l) => {
        const aberto = ABERTOS.includes(l.estado);
        const secundarias = aberto ? [
          podeAprovar && l.estado === "PENDENTE" ? { label: "Analisar", onClick: () => onAnalisar(l) } : null,
          podeAprovar ? { label: "Rejeitar", onClick: () => onRejeitar(l) } : null,
          podeCriar || podeAprovar ? { label: "Cancelar pedido", danger: true, onClick: () => onCancelar(l) } : null,
        ].filter(Boolean) : [];
        return (
          <CardItem key={l.id} style={{ cursor: "default" }}>
            <div className="linha">
              <span className="sub cresce">{l.fonte_display || l.fonte} · {l.tipo_material}{l.sobras_vinculadas ? ` · ${l.sobras_vinculadas} sobra(s) presa(s)` : ""}</span>
              <span className="fim"><Pill $tone={ESTADO_SC_TONE[l.estado]}>{ESTADO_SC_LABEL[l.estado] || l.estado_display}</Pill></span>
            </div>
            <div className="titulo" style={{ whiteSpace: "normal" }} title={l.nome}>{l.nome}</div>
            <div className="sub">{metaDe(l)}</div>
            {aberto && (podeAprovar || secundarias.length) ? (
              <div className="acoes">
                {podeAprovar ? (
                  <PrimaryButton type="button" className="principal" onClick={() => onCadastrar(l)}>Cadastrar</PrimaryButton>
                ) : null}
                <MenuSecundario itens={secundarias} nome={l.nome} />
              </div>
            ) : null}
          </CardItem>
        );
      })}
    </CardLista>
  );
}
